var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.5C3.5 2.94772 3.94772 2.5 4.5 2.5H22.5C23.0523 2.5 23.5 2.94771 23.5 3.5V13.5C23.5 14.0523 23.0523 14.5 22.5 14.5H11.686V16.5H13.5V19.5H11.5V21.5H19.5V19.5H15.5V16.5H22.5C24.1569 16.5 25.5 15.1569 25.5 13.5V3.5C25.5 1.84315 24.1569 0.5 22.5 0.5H4.5C2.84315 0.5 1.5 1.84315 1.5 3.5V6.5H3.5V3.5ZM2.5 21.5V10.5H7.5V21.5H2.5ZM0.5 21.5V10.5C0.5 9.39543 1.39543 8.5 2.5 8.5H7.5C8.60457 8.5 9.5 9.39543 9.5 10.5V21.5C9.5 22.6046 8.60457 23.5 7.5 23.5H2.5C1.39543 23.5 0.5 22.6046 0.5 21.5Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesLarge);
export default __webpack_public_path__ + "static/media/devices-large.6077e8a84a5b3d121f09ce0ac7d6387d.svg";
export { ForwardRef as ReactComponent };